import * as React from 'react';
import { Translate } from 'react-localize-redux';
import { useHistory } from 'react-router';
import { useRecoilValue } from 'recoil';
import { AInputSearch } from '../../atoms/filter/InputSearchFilter';
import styled from 'styled-components';
import Add from '../../components_v2/add/Add';
import CategorySelector, { Category } from '../../components_v2/Selector/CategorySelector';
import { isSuperAdmin } from '../../components_v2/utils';
import { AlertContext } from '../../containers_v2/alert/AlertProvider';
import { translateToString } from '../../styles/global/translate';
import PermissionContext from '../permissions/PermissionContext';
import { FlexDiv } from '../products/style';
import { NewReport } from './generic/generic';
import { SetSelectedReport } from './Reports';
import { TOOLBARS_HEIGHT } from '../globals/defaultToolbar/style/Style';

const StyledSpan = styled.span`
	font-size: 12px;
	font-weight: 300;
`;

export function ModalLeft(props: SetSelectedReport) {
	const { isAllowedTo } = React.useContext(PermissionContext);
	const isFormV2 = isAllowedTo({ objectAction: 'ViewForm' });
	const { alert } = React.useContext(AlertContext);
	const isAdmin = isSuperAdmin();
	const history = useHistory();
	const inputSearchText = useRecoilValue(AInputSearch);

	const reportKindList: Category[] = React.useMemo(() => {
		return [
			{
				name: <Translate id='shelf_audit.sections.shared_reports' />,
				restricted: { objectAction: 'ReadForm' },
				hidden: !isFormV2,
				children: [...[...props.reports].filter((r) => r.name.toLowerCase().includes(inputSearchText.toLowerCase())).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
					.map(r => {
						if (isAdmin || !r.name.toLowerCase().startsWith('superadmin'))
							return ({
								beta: false,
								admin: false,
								name: r.name,
								active: r.id.toString() === props.state.selectedReport,
								onClick: () => props.dispatch({ type: 'SET_SELECTED_REPORT', value: r.id.toString(), data: { ...r } }),
								report_id: r.id
							});
						return ({});
					}), {
					name: <FlexDiv gap='6px'><Add size='20px' /><StyledSpan><Translate id='reports.create_report'></Translate></StyledSpan></FlexDiv>,
					owner: true,
					create_report: true,
					onClick: () => {
						alert({
							title: translateToString('reports.name_report'),
							content: (onBreak, onOk) => <NewReport onBreak={onBreak} onOk={onOk} />,
							noButtons: true,
						});
					}
				}
				]
			}];
	}, [props.reports, props.state.selectedReport, inputSearchText]);

	React.useEffect(() => {
		if (props.state.selectedReport) {
			props.setIsModalOpen(true);
		}
	}, [props.state.selectedReport]);

	return (
		<div className="filter-modal" style={{ top: TOOLBARS_HEIGHT, height: `calc(100% - ${TOOLBARS_HEIGHT}px)`, left: '1px' }}>
			<div className={props.isModalOpen ? 'box-filter-modal' : 'd-none'} style={{ width: '260px' }}>
				<CategorySelector categories={reportKindList} hasSettings setUserCategoriesForList={props.setUserCategories} title={<div style={{ cursor: 'pointer' }} onClick={() => history.replace({ hash: 'list' })}><Translate id="reports.categories.report_categories" /></div>} />
			</div>
		</div>
	);
}
